<template>
  <el-container class="inner-container">
    <el-header style="height: 108px">
      <el-row
        justify="space-between"
        style="display: flex; align-items: flex-end"
      >
        <el-col :span="6">
          <img
            src="@/assets/logo.png"
            style="height: 80px; margin: 14px 0; float: right"
          />
        </el-col>
        <el-col :span="18">
          <div style="display: flex; justify-content: center">
            <div
              class="item"
              :style="{
                borderBottom: activeIndex == 1 ? '3px solid #1566FE' : '',
                color: activeIndex == 1 ? '#1566FE' : 'black',
              }"
              @click="activeIndex = 1"
            >
              首页
            </div>
            <div
              class="item"
              :style="{
                borderBottom: activeIndex == 0 ? '3px solid #1566FE' : '',
                color: activeIndex == 0 ? '#1566FE' : 'black',
              }"
              @click="activeIndex = 0"
            >
              SaaS
            </div>
            <el-dropdown
              :hide-on-click="false"
              @command="handleCommand"
              style="height: 55px"
            >
              <div
                class="item"
                :style="{
                  borderBottom:
                    activeIndex > 1 && activeIndex < 10
                      ? '3px solid #1566FE'
                      : '',
                  color:
                    activeIndex > 1 && activeIndex < 10 ? '#1566FE' : 'black',
                }"
              >
                产品
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="2">IOT</el-dropdown-item>
                <el-dropdown-item :command="3">TPM</el-dropdown-item>
                <el-dropdown-item :command="4">ANDON</el-dropdown-item>
                <el-dropdown-item :command="5">DNC</el-dropdown-item>
                <el-dropdown-item :command="6">硬件</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <div
              class="item"
              :style="{ borderBottom: activeIndex == 2 ? '3px solid #1566FE' : '', color: activeIndex == 2 ? '#1566FE' : '' }"
              @click="activeIndex = 2"
            >
              产品
            </div> -->
            <el-popover
              ref="popover1"
              placement="bottom"
              title="标题"
              width="200"
              trigger="hover"
              content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
            >
            </el-popover>
            <div
              class="item"
              :style="{
                borderBottom: activeIndex == 10 ? '3px solid #1566FE' : '',
                color: activeIndex == 10 ? '#1566FE' : 'black',
              }"
              @click="activeIndex = 10"
            >
              解决方案
            </div>
          </div>
        </el-col>
        <div style="flex: 1"></div>
      </el-row>
    </el-header>

    <div v-if="activeIndex == 0" style="background: #eef2fa">
      <div
        style="
          font-weight: bold;
          font-size: 36px;
          color: #000000;
          text-align: center;
          margin-top: 120px;
        "
      >
        选择最适合你的版本
      </div>
      <div
        style="
          font-size: 20px;
          color: #000000;
          text-align: center;
          margin-top: 40px;
          font-size: 15px;
        "
      >
        晓宝IoTPM设备管理SaaS服务是一款面向工业设备运维数字化、智能化管理的软件租赁服务，提供设备台账、设备点检、设备保养、设备维
      </div>
      <div
        style="
          font-size: 20px;
          color: #000000;
          text-align: center;
          font-size: 15px;
        "
      >
        修、设备故障、设备报表等功能，帮助企业实现设备的数字化管理，提升设备的运维效率和可靠性。
      </div>
      <el-row style="margin: 40px 18%" gutter="30">
        <el-col :span="6" style="position: relative">
          <img
            src="@/assets/images/t1.png"
            class="box"
            style="width: 94%; margin: 0 3%; height: auto"
          />
          <img
            src="@/assets/images/b1.png"
            style="width: 92%; margin: 0 4%; height: auto"
          />
          <a
            class="button"
            href="https://shebeicloud.feishu.cn/share/base/form/shrcnnkqXjrY8y43yLbSIldmoVb"
            target="_blank"
            >免费使用</a
          >
        </el-col>
        <el-col :span="6" style="position: relative">
          <img
            src="@/assets/images/t2.png"
            class="box"
            style="width: 94%; margin: 0 3%; height: auto"
          />
          <img
            src="@/assets/images/b2.png"
            style="width: 92%; margin: 0 4%; height: auto"
          />
          <a
            class="button"
            href="https://shebeicloud.feishu.cn/share/base/form/shrcnnkqXjrY8y43yLbSIldmoVb"
            target="_blank"
            >联系我们</a
          >
        </el-col>
        <el-col :span="6" style="position: relative">
          <img
            src="@/assets/images/t3.png"
            class="box"
            style="width: 94%; margin: 0 3%; height: auto"
          />
          <img
            src="@/assets/images/b3.png"
            style="width: 92%; margin: 0 4%; height: auto"
          />
          <a
            class="button"
            href="https://shebeicloud.feishu.cn/share/base/form/shrcnnkqXjrY8y43yLbSIldmoVb"
            target="_blank"
            >联系我们</a
          >
        </el-col>
        <el-col :span="6" style="position: relative">
          <img
            src="@/assets/images/t4.png"
            class="box"
            style="width: 94%; margin: 0 3%; height: auto"
          />
          <img
            src="@/assets/images/b4.png"
            style="width: 92%; margin: 0 4%; height: auto"
          />
          <a
            class="button"
            style="background: #3a72ef; color: white"
            href="https://shebeicloud.feishu.cn/share/base/form/shrcnnkqXjrY8y43yLbSIldmoVb"
            target="_blank"
            >联系我们</a
          >
        </el-col>
      </el-row>
      <div class="testdemo">
        <el-row
          justify="center"
          style="margin: 0 20%; display: flex; align-items: center"
        >
          <el-col :span="12" style="color: white; margin-top: 30px">
            <div style="font-size: 26px; font-weight: bold">体验账号</div>
            <div class="text_item" style="margin-top: 20px">
              企业编号：641983
            </div>
            <div class="text_item">账号：demo</div>
            <div class="text_item">密码：iotpm888</div>
          </el-col>
          <el-col :span="8" style="text-align: center; margin-top: 60px">
            <span>
              <el-popover
                placement="top-start"
                trigger="hover"
                :show-after="2000"
              >
                <template #reference>
                  <a
                    class="button2"
                    style="background: white; color: black"
                    href="https://x.xiaobaoiot.cn"
                    target="_blank"
                  >
                    立即体验
                  </a>
                </template>
                <img
                  src="@/assets/images/wxb.jpg"
                  style="display: block; height: 200px; margin-top: 15px"
                />
              </el-popover>
            </span>
          </el-col>
          <el-col :span="4" style="text-align: center; margin-top: 60px">
            <a
              class="button2"
              style="background: #ffffff33; color: white"
              href="https://shebeicloud.feishu.cn/share/base/form/shrcnnkqXjrY8y43yLbSIldmoVb"
              target="_blank"
            >
              试用申请
            </a>
          </el-col>
        </el-row>
      </div>
    </div>

    <div v-if="activeIndex == 1">
      <el-carousel height="28vw">
        <el-carousel-item v-for="item in banners" :key="item.url">
          <img :src="item.img" />
        </el-carousel-item>
      </el-carousel>
      <div style="width: 100vw; height: auto">
        <img src="@/assets/images/m1.jpg" style="width: 100%; height: 100%" />
      </div>
      <div style="width: 100vw; height: auto">
        <img src="@/assets/images/m2.jpg" style="width: 100%; height: 100%" />
      </div>
      <div style="width: 100vw; height: auto">
        <img src="@/assets/images/m3.jpg" style="width: 100%; height: 100%" />
      </div>
    </div>

    <div
      v-if="
        activeIndex == 2 ||
        activeIndex == 3 ||
        activeIndex == 4 ||
        activeIndex == 5 ||
        activeIndex == 6
      "
    >
      <el-carousel height="500px">
        <el-carousel-item v-for="item in banners2" :key="item.url">
          <img :src="item.img" />
        </el-carousel-item>
      </el-carousel>
      <div v-if="activeIndex == 2" style="width: 100vw; height: auto">
        <img src="@/assets/images/iot.jpg" style="width: 100%; height: 100%" />
      </div>
      <div v-if="activeIndex == 3" style="width: 100vw; height: auto">
        <img src="@/assets/images/tpm.jpg" style="width: 100%; height: 100%" />
      </div>
      <div v-if="activeIndex == 4" style="width: 100vw; height: auto">
        <img
          src="@/assets/images/andon.jpg"
          style="width: 100%; height: 100%"
        />
      </div>
      <div v-if="activeIndex == 5" style="width: 100vw; height: auto">
        <img src="@/assets/images/dnc.jpg" style="width: 100%; height: 100%" />
      </div>
      <div v-if="activeIndex == 6" style="width: 100vw; height: auto">
        <img
          src="@/assets/images/device.png"
          style="width: 100%; height: 100%"
        />
      </div>
    </div>

    <div v-if="activeIndex == 10">
      <div style="padding: 8vw 15vw">
        <el-carousel height="40vw">
          <el-carousel-item v-for="item in bannersjjfa" :key="item.url">
            <img
              :src="item.img"
              mode="aspectFill"
              style="width: 100%; height: 100%"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- <div style="width: 100vw; height: auto">
        <img src="@/assets/images/fa.jpg" style="width: 100%; height: 100%" />
      </div> -->
      <!-- <div style="width: 1080px;height: auto;">
				<img src="@/assets/images/iot.jpg" style="width: 100%;height: 100%;"/>
			</div> -->
    </div>

    <el-footer style="background-color: #f5f6fa; margin-top: -4px">
      <el-row
        justify="space-between"
        style="
          display: flex;
          align-items: center;
          margin-top: 58px;
          background-color: #f5f6fa;
        "
      >
        <el-col :span="9">
          <img
            src="@/assets/logo.png"
            style="display: block; height: 78px; margin: 0 auto"
          />
          <div style="text-align: center; font-size: 20px; margin-top: 38px">
            设备物联网解决方案提供商
          </div>
        </el-col>
        <el-col :span="9">
          <div style="font-size: 26px; font-weight: bold">联系方式</div>
          <div style="font-size: 20px; margin-top: 38px">
            公司地址：无锡市惠山区华智科技园8号楼203室
          </div>
          <div style="font-size: 20px; margin-top: 18px">
            联系电话：18961705211
          </div>
        </el-col>
        <el-col :span="6">
          <div style="font-size: 26px; font-weight: bold; margin-left: 15px">
            公众号
          </div>
          <img
            src="@/assets/images/gzh.jpg"
            style="display: block; height: 200px; margin-top: 15px"
          />
        </el-col>
      </el-row>
      <el-row style="background-color: #f5f6fa">
        <div style="text-align: center; font-size: 20px">
          备案号：苏ICP备2025158039号
        </div>
        <!-- <div style="float:right">版权所有：无锡晓宝科技有限公司</div> -->
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "main",
  metaInfo() {
    return {
      meta: [
        {
          keywords:
            "设备智能维保、预测性维护解决方案、工业物联网(IIoT)、设备生命周期管理、智能制造解决方案、设备联网数据采集、智能仓储柜解决方案、工业安灯系统、工艺参数优化、工艺参数实时监测、智能制造数据管理、设备状态实时监控、设备数据云端管理、工业设备数据可视化、工业设备联网解决方案、设备维护SaaS平台、TPM、EAM、SCADA、MDC、DNC",
        },
      ],
    };
  },
  data() {
    return {
      activeIndex: 1,
      banners: [
        { img: require("@/assets/images/banner3.jpg") },
        { img: require("@/assets/images/banner.jpg") },
        { img: require("@/assets/images/dncbanner.jpg") },
        { img: require("@/assets/images/tpmbanner.jpg") },
      ],
      banners2: [{ img: require("@/assets/images/banner2.jpg") }],
      bannersjjfa: [
        { img: require("@/assets/images/jjfa1.jpg") },
        { img: require("@/assets/images/jjfa2.jpg") },
        { img: require("@/assets/images/jjfa3.jpg") },
        { img: require("@/assets/images/jjfa4.jpg") },
        { img: require("@/assets/images/jjfa5.jpg") },
      ],
    };
  },
  methods: {
    handleCommand(command) {
      this.activeIndex = command;
    },
  },
};
</script>
<style lang="css">
body {
  margin: 0 !important;
  overflow: hidden;
}
.inner-container {
  position: absolute;
  left: 0;
  top: 0;
  right: -17px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
<style scoped>
body {
  margin: 0 !important;
}
.item {
  display: inline;
  font-size: 28px;
  padding: 0 15px 15px 15px;
  margin: 0 60px;
}

/* 修改背景色以及border颜色*/
.el-dropdown-menu {
}
/* 修改小三角的样式 这里自定义类名与第三方组件的类中间一定不要有空格,不然更改无效!!!*/
.el-dropdown-menu.el-popper[x-placement^="bottom"] .popper__arrow::after,
.el-dropdown-menu.el-popper[x-placement^="bottom"] .popper__arrow {
}
.el-dropdown-menu.el-dropdown-menu--medium
  .el-dropdown-menu__item.el-dropdown-menu__item--divided:before {
  height: 0;
}
/* 修改每一项的字体颜色,这里因为是里层的类,所以中间要加上空格!!!*/
.el-dropdown-menu .el-dropdown-menu__item--divided {
}
.el-dropdown-menu .el-dropdown-menu__item {
  width: 150px;
  text-align: center;
  padding: 15px auto;
  font-size: 26px;
}
.el-dropdown-menu .el-dropdown-menu__item:hover {
}

.box {
  border-radius: 10px;
  transition: box-shadow 0.3s ease; /* 平滑过渡效果 */
}

.box:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); /* 添加阴影效果 */
}

.button {
  position: absolute;
  top: 23%;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 20px;
  border: 1px solid #3a72ef;
  border-radius: 5px;
  text-decoration: none;
  color: #3a72ef;
}
.testdemo {
  background-image: url("../assets/images/saas_bg.png");
  background-size: 100% 100%;
  height: 200px;
  width: 100vw;
}

.text_item {
  font-size: 16px;
  margin-top: 5px;
}
.button2 {
  padding: 8px 40px;
  border: 1px solid white;
  border-radius: 5px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/IndexView.vue